module.exports = __webpack_public_path__ + "img/Whatsapp.2c8c791d.svg";